/**
 * Day view — single-column 24-hour time grid with positioned event blocks.
 *
 * @module components/calendar/DayView
 */

import { useMemo } from 'react'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { meetingVisibleOnDay, packTracks } from '../../utils/calendarLayout'
import TimeGrid from './TimeGrid'
import EventBlock from './EventBlock'

const HOUR_HEIGHT = 60

export default function DayView({ meetings, currentDate, userTz }) {
  const dayMeetings = useMemo(
    () => meetings.filter((m) => meetingVisibleOnDay(m, currentDate, userTz)),
    [meetings, currentDate, userTz]
  )

  const packed = useMemo(
    () => packTracks(dayMeetings, userTz, HOUR_HEIGHT),
    [dayMeetings, userTz]
  )

  const dateInTz = utcToZonedTime(currentDate, userTz)
  const headers = [
    {
      label: format(dateInTz, 'EEE'),
      sublabel: format(dateInTz, 'd'),
      date: currentDate,
    },
  ]

  return (
    <div className="glass rounded-2xl overflow-hidden">
      <TimeGrid
        columnCount={1}
        columnHeaders={headers}
        hourHeight={HOUR_HEIGHT}
        userTz={userTz}
        currentDate={currentDate}
        renderColumn={() =>
          packed.map((item) => (
            <EventBlock
              key={item.meeting.id ?? item.meeting.meetingId ?? `${item.top}`}
              meeting={item.meeting}
              top={item.top}
              height={item.height}
              track={item.track}
              totalTracks={item.totalTracks}
              userTz={userTz}
            />
          ))
        }
      />
      {dayMeetings.length === 0 && (
        <div className="text-center py-12 text-gray-400 text-sm">
          No meetings scheduled for this day
        </div>
      )}
    </div>
  )
}
